import anime from 'animejs';

import {ConnectedComponent} from '@lib/ConnectedComponent';
import {MediaQuery} from '@services/MediaQuery';

export class Video extends ConnectedComponent {
  private mq = MediaQuery.create();
  private video: HTMLVideoElement | null = null;
  private img: HTMLImageElement | null = null;

  constructor() {
    super();
    this.onEnterMouse = this.onEnterMouse.bind(this);
    this.onLeaveMouse = this.onLeaveMouse.bind(this);
    this.onCanPlay = this.onCanPlay.bind(this);
  }

  didMount() {
    this.video = this.element?.querySelector('video') as HTMLVideoElement;
    this.img = this.element?.querySelector('.a-video_img') as HTMLImageElement;

    this.on('mouseenter', this.onEnterMouse);
    this.on('mouseleave', this.onLeaveMouse);

    if (this.mq.isDesktop()) {
      this.video.addEventListener('canplay', this.onCanPlay);
      this.video.preload = 'auto';
      // this.video.load();
    }
  }

  onCanPlay() {}

  onEnterMouse() {
    if (this.mq.isPhone()) {
      return;
    }
    this.video?.play();
    anime({
      duration: 300,
      easing: 'easeInOutCubic',
      opacity: 0,
      targets: this.img,
    });
  }

  onLeaveMouse() {
    if (this.mq.isPhone()) {
      return;
    }
    anime({
      duration: 300,
      easing: 'easeInOutCubic',
      opacity: 1,
      targets: this.img,
    });
    this.video?.pause();
  }
}
